// extracted by mini-css-extract-plugin
module.exports = {"tituloSecao":"ModalMaisDetalhes_tituloSecao__Ekpx2","botaoEvento":"ModalMaisDetalhes_botaoEvento__35MKg"};